<template>
  <div class="wrapper" ref="content">
    <div class="top-right-nav">
      <ul>
        <li v-if="lotterySetting.is_open == 1 && (liveStatus == 3 || liveStatus == 5)" key="lottery" class="lottery"
          @click="toMarket('lottery', 'isShowLottery')">
          <img :src="lotterySetting.icon_img" alt="">
          <span v-if="!isShowLotteryLeftTime">免费抽奖</span>
          <span v-else>{{ lotteryLeftTime[1] }}:{{ lotteryLeftTime[2] }}</span>
        </li>
        <li v-if="formEntryInfo.activity_switch == '1' && (liveStatus == 3 || liveStatus == 5)" key="form" class="form"
          @click="toMarket('form', 'isShowForm')">
          <img :src="formEntryInfo.icon" alt="">
          <span v-if="formEntryInfo.enroll_num_switch == '1'">
            {{ formEntryInfo.enroll_num | fl_enroll_num }}
          </span>
        </li>
      </ul>
    </div>
    <no-data v-if="liveStatus == 'err'"></no-data>
    <!-- 主播信息   -->
    <div class="follow-person">
      <div class="head-left">
        <div class="head-icon">
          <img @click="enterPerson(anchorObj.uid)" :src="anchorObj.avatar" alt=""
            onerror="this.onerror=null;this.src='https://s.kcimg.cn/app/quick/images/default-head.png'">
        </div>
        <div class="info">
          <span @click="enterPerson(anchorObj.uid)" class="com-one-line-els">{{ anchorObj.nickname }}</span>
          <span v-if="liveStatus == 3" class="com-one-line-els">{{ onlineNumber }} 观看</span>
        </div>
      </div>
      <!--非自己的没有关注按钮-->
      <div v-if="myInfo.uid != anchorObj.uid" :class="['follow-button', !anchorObj.is_follow ? '' : 'followed']"
        @click="followUser">{{ !anchorObj.is_follow ? '关注' : '已关注' }}
      </div>
      <img src="../../assets/share.png" alt="" class="share" @click="toShareMask(true)">
    </div>
    <!--直播预告-->
    <div class="live-trailer" v-if="liveStatus == 2 || liveStatus == 6">
      <!--  直播视频预告    -->
      <video :poster="liveObj.room.img" v-if="liveObj.room.prepare_mode === '2'" id="live-player-notice"
        class="live-player" preload="auto" playsinline webkit-playsinline>
      </video>
      <!--  直播    -->
      <img :src="liveObj.room.img" alt="" v-else>
      <div v-if="isShowIllustrate" :class="['trailer-mask', liveObj.room.prepare_mode === '2' ? 'notice-style' : '']">
        <p>{{ leftShowTime }}开播</p>
        <div class="label" v-if="liveStatus == 2">
          <div class="left">剩余</div>
          <div class="time">
            <em>{{ leftTime[0] }}</em><span>时</span><em>{{ leftTime[1] }}</em><span>分</span><em>{{ leftTime[2]
            }}</em><span>秒</span>
          </div>
        </div>
        <span v-else>主播正在赶来的路上 请耐心等待～</span>
      </div>
    </div>
    <!--直播播放器-->
    <div id="live-player" class="live-player" v-else-if="liveStatus == 3">
    </div>
    <!--直播结束-->
    <div class="live-end" v-else-if="liveStatus == 4 || liveStatus == 7">
      <img :src="liveObj.room.img" alt="">
      <div class="trailer-mask">
        <p>{{ liveStatus == 4 ? '直播已结束' : '对不起，直播已中断' }}</p>
      </div>
    </div>
    <!--回放播放器-->
    <video :poster="liveObj.room.img" v-else-if="liveStatus == 5" id="live-player-review" class="live-player"
      preload="auto" playsinline webkit-playsinline>
    </video>
    <div class="openAppBtn" v-if="this.type !== 'app'" @click.prevent="clickDownload">
      <!--      <span>打开APP，看更多精彩内容</span>-->
      打开APP，看更多精彩内容
      <!--      <div id="open-app-first" class="wx-id-block"></div>-->
    </div>
    <!--tab项切换-->
    <div class="nav" v-if="tabs.length > 1 && liveStatus != 'err'">
      <div class="nav-item" v-for="(item, index) in tabs" :key="index" :class="[tabActived === index ? 'on' : '']">
        <p @click="tabSelect(index)">{{ item }}</p>
      </div>
    </div>
    <!--tab列表-->
    <div class="tab-list" v-if="liveObj.user && liveStatus != 'err'">
      <div class="comment-tab" v-show="tabActived === 1 && tabs.length > 1">
        <!--                        <div class="swiper-wraper">-->
        <div class="m-t-12 m-b-12" v-if="adData.text !== '' || (adData.images && adData.images.length)">
          <ad-scroll v-if="adData.text !== '' && adData.position === '2'" :data="adData"></ad-scroll>
          <div class="my-swiper-wraper" v-if="adData.images && adData.images.length" :class="{
            'm-t-8': adData.text !== '' && adData.position === '2',
            'm-b-8': adData.text !== '' && adData.position === '1'
          }">
            <swiper class="my-swiper" ref="mySwiper" :options="swiperOptions">
              <swiper-slide v-for="(item, index) in adData.images" :key="index">
                <figure>
                  <img :src="item.whole_img" :url="item.url" :id="item.id" alt="">
                </figure>
              </swiper-slide>
            </swiper>
            <div class="swiper-pagination" v-if="adData.images.length > 1"></div>
          </div>
          <ad-scroll v-if="adData.text !== '' && adData.position === '1'" :data="adData"></ad-scroll>
        </div>
        <!--        直播中评论列表-->
        <ul class="comment-list" ref="commentList" v-if="liveStatus == 3">

          <template v-for="(item, index) in commentList">
            <!--发表评论-->
            <li v-if="item.action === 103" class="comment-item" :key="index">
              <div class="head-icon">
                <img :src="item.avatar" alt=""
                  onerror="this.onerror=null;this.src='https://s.kcimg.cn/app/quick/images/default-head.png'">
              </div>
              <div class="item-info">
                <div class="title">
                  <div class="tag" v-if="item.uid == anchorObj.uid"></div>
                  <span>{{ item.nickname }}</span>
                </div>
                <p class="word" v-if="item.msgType === 'text'">{{ item.content }}</p>
                <p class="word link" v-if="item.msgType === 'link'" v-html="$options.filters.splitUrl(item.content)"></p>
              </div>
            </li>
            <!--进入了直播间-->
            <li v-else class="enter-live" :key="index">
              <span>{{ item.nickname }}</span><span>进入了直播间</span>
            </li>
          </template>
        </ul>
        <!--回放评论列表-->
        <ul class="comment-list" ref="commentList" v-if="liveStatus == 5">
          <li v-for="(item, index) in commentList" :class="['comment-item']" :key="index">
            <div class="head-icon">
              <img :src="item.avatar" alt=""
                onerror="this.onerror=null;this.src='https://s.kcimg.cn/app/quick/images/default-head.png'">
            </div>
            <div class="item-info">
              <div class="title">
                <div class="tag" v-if="(item.is_anchor === '1' || item.is_anchor === 1)"></div>
                <span>{{ item.nickname }}</span>
              </div>
              <p class="word" v-if="item.msg_type === 'text'">{{ item.content }}</p>
              <p class="word link" v-if="item.msg_type === 'link'" v-html="$options.filters.splitUrl(item.content)"></p>
            </div>
          </li>
          <div class="empty" v-if="commentLoad && !commentList.length">
            <img src="../../assets/empty.png" alt="">
            <p>暂无评论，快来抢沙发呦～</p>
          </div>
        </ul>
      </div>
      <div class="brief" v-show="(tabActived === 0 && tabs.length > 1) || tabs.length < 2">
        <h4>{{ liveObj.room.title }}</h4>
        <div class="notice">
          <img src="../../assets/notice-icon.png" alt="">
          <article v-html="liveObj.room.h5_notice">
          </article>
          <img v-if="(liveStatus == 2 || liveStatus == 6) && liveObj.room.flow_image" :src="liveObj.room.flow_image"
            alt="流程图" class="flow-chart-img">
        </div>
      </div>
      <div class="flow-chart" v-show="tabActived === 2 && tabs.length > 1">
        <img :src="liveObj.room.flow_image" alt="" class="flow-chart-img">
      </div>
    </div>
    <!--评论吸底-->
    <div class="comment-footer" v-if="tabActived === 1 && tabs.length > 1 && liveStatus != 'err'">
      <!-- <div class="comment-footer" > -->
      <div class="footer-left" v-if="liveObj && liveObj.room && liveObj.room.type == '3'">
        <div class="footer-left-btn" @click="enterPrice(askPrice.url, askPrice.car_id)"
          v-if="roomDistributor.isInquiry == 1">
          <img src="../../assets/price-icon.png" alt="">
          <span>询底价</span>
        </div>
        <div class="footer-left-btn" @click="enterModelList" v-if="roomDistributor.isHasCar == 1">
          <img src="../../assets/model-icon.png" alt="">
          <span>车型</span>
        </div>
      </div>
      <div class="footer-right">
        <div class="input" v-if="(!myInfo.uid) || (liveStatus == 5 && type == 'app')" @click="appComment">让我说几句...</div>
        <div class="inputDiv" v-else><input class="input" type="text" maxlength="200" v-model="commentVal"
            placeholder="让我说几句..." @click="beforeComment" @focus="inputFocus" @blur="onBlur" @keyup.enter="comment"></div>
        <button :class="btnDisabled ? 'disabled' : ''" v-if="liveStatus != 5 || type != 'app'"
          @click="comment">发布</button>
      </div>
    </div>
    <share-mask v-if="shareMask" @shareMask="toShareMask"></share-mask>
    <right-nav v-if="liveStatus == 3" @toLike="toLike" :zanNumber="zanNumber" :liveStatus="liveStatus"
      :isShoppingOpen="shoppingConf.shopping_open === '1'" ref="rightNav" @openGoodList="isShowGoodList = true"></right-nav>
    <!-- 转盘 -->
    <lottery v-if="lotterySetting.is_open == 1 && isShowLottery && (liveStatus == 3 || liveStatus == 5)"
      :setData="lotterySetting" :uid="myInfo.uid" @login="beforeComment" @close="toMarket('close', 'isShowLottery')">
    </lottery>
    <!--  留资  -->
    <retain-capital v-if="isShowForm && (liveStatus == 3 || liveStatus == 5)" :setData="formEntryInfo" :uid="myInfo.uid"
      :phone="myInfo.phone" @login="beforeComment" @close="toMarket('close', 'isShowForm')"></retain-capital>
    <!-- 商品讲解 -->
    <explain v-if="shoppingConf.shopping_open === '1' && (liveStatus == 3)" :setData="shoppingConf">
    </explain>
    <!-- 购物车列表-->
    <good-list :rid="liveId" v-if="isShowGoodList&&shoppingConf.shopping_open === '1'" @close="toMarket('close', 'isShowGoodList')"></good-list>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import md5 from 'md5'
import 'swiper/css/swiper.css'
import XHR from '../../api/index'
import NoData from '../../components/noData'
import ShareMask from '../../components/ShareMask'
import AdScroll from '../../components/AdScroll'
import RightNav from '../../components/RightNav'
import Lottery from '../../components/Lottery'
import RetainCapital from '../../components/RetainCapital'
import Explain from '../../components/Explain'
import GoodList from '../../components/GoodList'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

let vm = null
let lpn = null
let libFirst = null
export default {
  data: () => ({
    shareMask: false,
    type: '',
    // 直播id
    liveId: 0,
    // 回放id,回放评论列表和聊天接口需求
    replayId: 0,
    // 主播信息
    anchorObj: {},
    // 分享三要素
    shareObj: {},
    // 直播状态
    liveStatus: '',
    // 当前选中
    tabActived: 1,
    // 评论列表
    commentList: [],
    // 评论绑定值
    commentVal: '',
    // 预告倒计时定时器
    timer: '',
    nowTime: '',
    // 直播间信息
    liveObj: {},
    // 预告倒计时相关
    leftShowTime: '',
    leftSec: 0,
    leftTime: '',
    // 自己的信息
    myInfo: {
      uid: '',
      nickname: '',
      fd: 0,
      phone: ''
    },
    // 关注加锁
    followLock: false,
    // 当前直播长链接
    liveSocket: null,
    // 心跳定时器
    heartTimer: '',
    // 心跳包超时定时器
    serverTimeout: '',
    // socket加锁
    socketLock: false,
    // 重连次数
    reconectNum: 0,
    // socket改变
    socketChange: false,
    // 重连定时器，3s后再重连
    reconectTimer: '',
    // 评论加锁
    commentLock: false,
    // 网络错误
    socketError: false,
    // 评论定时器
    commentTimer: '',
    // 切换tab时评论高度
    tabCommentHeight: 'bottom',
    // 输入时评论高度
    commentBottom: true,
    // 是否ios
    isIOS: false,
    // 回放评论加载完成
    commentLoad: false,
    // 直播间是否开启询底价，是否开启配置车型
    roomDistributor: {
      // 询底价 0是未开启 1是开启
      isInquiry: 0,
      // 车型 0是未配置 1是配置
      isHasCar: 0
    },
    // 询底价信息
    askPrice: {},
    adData: {},
    swiperOptions: {
      autoplay: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      on: {
        click: (e) => {
          const val = e.target.attributes.url.value
          const id = e.target.attributes.id.value
          vm.openUrl(val, 'img', id)
        }
      },
      pagination: {
        el: '.swiper-pagination', // 与slot="pagination"处 class 一致
        clickable: true // 轮播按钮支持点击
      }
    },
    onlineNumber: 0, // 在线人数即观看数
    zanNumber: 0, // 点赞数,
    // 评论定时器
    likeTimer: '',
    likeLock: false,
    timeupdateCounter: false,
    playStatus: '',
    playCounter: 0,
    pauseCounter: 0,
    lotterySetting: {},
    formEntryInfo: {},
    shoppingConf: {},
    isShowLottery: false,
    isShowForm: false,
    isShowLotteryLeftTime: false,
    lotteryLeftTime: '',
    isShowIllustrate: true,
    // 是否显示购物车列表
    isShowGoodList: false
  }),
  components: {
    NoData,
    AdScroll,
    ShareMask,
    RightNav,
    Swiper,
    SwiperSlide,
    Lottery,
    RetainCapital,
    Explain,
    GoodList
  },
  beforeCreate () {
    // 进入页面判断是否登录
    if ((location.host.indexOf('live-h5.360che.com') > -1) || (location.host.indexOf('live-h5-test.360che.com') > -1)) {
      window.truckLogin.init()
    }
  },
  created () {
    vm = this
    const UA = navigator.userAgent
    if (!(/android/i).test(UA)) {
      this.isIOS = true
    }
    // 微信分享
    this.wxConfig()
    this.type = this.checkPlatform()
    this.liveId = location.href.match(/liveId=(\d+)/) ? location.href.match(/liveId=(\d+)/)[1] : 0
    if (!this.liveId) {
      document.querySelector('#loading').style.display = 'none'
      this.liveStatus = 'err'
      return
    }
    if (window.truckLogin.uid && window.truckLogin.uid !== '0') {
      this.myInfo.uid = window.truckLogin.uid
      this.getName()
      this.getLiveRoomInfo()
    } else {
      // 未登录用户直接访问
      this.getLiveRoomInfo()
    }
    this.getPromoteData()
    this.getLotterySetting()
    this.getFormEntryInfo()
  },
  computed: {
    tabs () {
      if (this.liveStatus === '5' || (this.liveStatus === '3' && !this.liveObj.room.flow_image)) {
        return ['简介', '聊天']
      } else if (this.liveStatus === '3' && this.liveObj.room.flow_image) {
        return ['简介', '聊天', '流程图']
      } else {
        return ['简介']
      }
    },
    btnDisabled () {
      if (!this.commentVal.trim()) {
        return true
      } else {
        return false
      }
    }
  },
  filters: {
    splitUrl (text) {
      const re = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
      const s = text.replace(re, function (a) {
        if (a !== '') {
          return '<a href="' + a + '" target=_blank>' + a + '</a>'
        } else {
          return ''
        }
      })
      return s
    },
    fl_enroll_num (text) {
      const num = parseInt(text)
      let result = num
      if (num >= 10000) {
        if (num / 10000 <= 999) {
          result = `${Math.round(num / 10000 * 10) / 10}万`
        } else {
          result = '999+万'
        }
      }
      return result
    }
  },
  mounted () {
    // 为app内的ios添加样式
    if (this.type === 'app' && this.isIOS) {
      this.addStylesheetRules([
        [
          '.vjs-fullscreen-control',
          ['display', 'none', true]
        ]
      ]
      )
    }
    //
    const that = this
    var originHeight =
      document.documentElement.clientHeight || document.body.clientHeight
    window.addEventListener('resize', function () {
      var resizeHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      if (resizeHeight >= originHeight) {
        // Android 键盘收起后操作
        that.$nextTick(() => {
          if (that.$refs.commentList && that.commentBottom) {
            that.$refs.commentList.scrollTop = that.$refs.commentList.scrollHeight
          }
        })
      }
      // 安卓解决键盘弹起遮盖输入框
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        window.setTimeout(function () {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    })
    // 获取询底价信息
    that.getPrice()
  },
  beforeDestroy () {
    // 关闭页面前关闭定时器
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.heartTimer) {
      clearTimeout(this.heartTimer)
    }
    if (this.serverTimeout) {
      clearTimeout(this.serverTimeout)
    }
    if (this.reconectTimer) {
      clearTimeout(this.reconectTimer)
    }
    if (this.liveSocket) {
      this.socketChange = true
      this.liveSocket.close()
    }
  },
  methods: {
    toLogin () {
      if (this.deviceType === 'weixin') {
        window.truckhomeAccountBinding.autoLogin()
        return
      }
      window.truckLogin.toLogin(this.onLoginCallback)
    },
    // 生成lib实例
    libExample (id) {
      const protocol = 'truckhomefuse'
      const option = {
        scheme: {
          protocol
        },
        wxAppid: 'wx3cc08b56b3f3077c',
        appstore:
          'https://apps.apple.com/app/apple-store/id653300680?pt=986281&ct=MDiversion&mt=8',
        yingyongbao:
          'https://a.app.qq.com/o/simple.jsp?pkgname=com.truckhome.bbs',
        fallback: 'https://download.360che.com/quickapp/share-guide.html',
        timeout: 200
      }
      const UA = navigator.userAgent
      // ios端
      if (/(iPhone|iPad|iPod|iOS)/i.test(UA)) {
        option.universal = {
          host: 'app.360che.com'
        }
      }
      // eslint-disable-next-line no-undef
      return new CallApp(option)
    },
    // 配置可拉起app按钮
    wxPullApp (config = {}, lib) {
      config.path = '360chefuse.com'
      config.callback = () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          const universalLink = `truckhomefuse://360chefuse.com?type=liveDetail&id=${this.liveId}`
          this.copy(universalLink)
        }
      }
      lib.open(config)
    },
    // 倒计时
    getCountDown (leftSec = 0, key = '') {
      this[key] = true
      const timer = setInterval(() => {
        if (leftSec <= 0) {
          clearInterval(timer)
          this[key] = false
        }
        leftSec = leftSec - 1
        this.lotteryLeftTime = this.checkLeftTime(leftSec)
      }, 1000)
    },
    // 获取转盘抽奖设置
    getLotterySetting () {
      XHR.getLotterySetting({ id: this.liveId }).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.lotterySetting = data
          if (data.left_time > 0 && data.left_time <= 300) {
            this.getCountDown(data.left_time, 'isShowLotteryLeftTime')
          }
        }
      })
    },
    // 获取留资活动入口信息
    getEntryinfo (type = '', key = '') {
      if (!this.myInfo.uid && this.myInfo.uid !== '0') {
        this.toLogin()
        return false
      } else {
        this[key] = true
      }
    },
    // 获取留资活动入口信息
    getFormEntryInfo (type = '', key = '') {
      const params = {
        rid: this.liveId
      }
      if (this.myInfo.uid) {
        params.uid = this.myInfo.uid
      }
      XHR.getFormEntryInfo(params).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.formEntryInfo = data
          if (type === 'entry') {
            if (data.is_tip === 1) {
              this.showErrorInfo(data.tip_msg)
              return false
            } else {
              if (data.enroll_limit === '1' && (!this.myInfo.uid && this.myInfo.uid !== '0')) {
                this.toLogin()
                // window.truckLogin.toLogin(this.onLoginCallback)
                return false
              } else {
                this[key] = true
              }
            }
          }
        }
      })
    },
    // 进入直播间获取购物车状态以及正在直播的商品信息
    getShoppingConf (type = '', key = '') {
      const params = {
        rid: this.liveId
      }
      if (this.myInfo.uid) {
        params.uid = this.myInfo.uid
      }
      XHR.getShoppingConf(params).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.shoppingConf = data
        }
      })
    },
    // 营销活动
    async toMarket (type = '', key = '') {
      if (type === 'close') {
        this[key] = false
      }
      if (type === 'lottery') {
        // 调接口
        this.sendTruckhomeEvent('ck_luck_draw', '', `直播|${this.liveId}`)
        this.getEntryinfo(type, key)
        // this[key] = true
      } else if (type === 'form') {
        this.sendTruckhomeEvent('ck_leave_info', '', `直播|${this.liveId}`)
        this.getFormEntryInfo('entry', key)
      }
    },
    // 活动开始，结束
    // 关闭弹层
    toShareMask (flag) {
      this.shareMask = flag
    },
    // 点击
    clickDownload () {
      try {
        // eslint-disable-next-line no-undef
        Truckhome_eventFun('ck_open_app', '打开APP看更多精彩内容', '直播')
      } catch (e) {
      }

      const wxPullAppConfigure = {
        param: {
          type: 'liveDetail',
          id: this.liveId
        }
      }
      this.wxPullApp(wxPullAppConfigure, libFirst)
    },
    // 进入车型列表
    enterModelList () {
      location.href = './modelList.html?liveId=' + this.liveId
      this.sendAnalytics('经销商直播', '点击车型列表', '')
    },
    // 获取询底价信息
    getPrice () {
      XHR.getPrice({ id: this.liveId }).then(res => {
        this.askPrice = res.data.data
      })
    },
    // 点击进入寻底价
    enterPrice (url, id) {
      this.sendAnalytics('经销商直播', '点击询底价', '')
      this.sendTruckhomeEvent('ck_live_ap', 'info.live_' + this.liveId + '.bottom.0', id)
      location.href = url + '&spm=info.live_' + this.liveId + '.bottom.0'
    },
    // 登录回调
    onLoginCallback () {
      this.myInfo.uid = window.truckLogin.uid
      this.$nextTick(() => {
        // window.location.reload()
        this.getFollowStatus()
      })
    },
    // 获取用户昵称
    async getName () {
      const res = await XHR.getMyInfo({
        uid: this.myInfo.uid
      })
      const { data, status } = res.data
      if (!status) {
        this.$set(this.myInfo, 'nickname', data.nickname)
        this.$set(this.myInfo, 'avatar', data.avatar)
        this.$set(this.myInfo, 'phone', data.sjyz)
      }
    },
    // 直播间相关数据获取
    getLiveRoomInfo () {
      XHR.getLiveRoom({
        uid: this.myInfo.uid,
        id: this.liveId
      }).then(res => {
        const { data, status } = res.data
        const { room, user } = data
        if (status === 30002) {
          document.querySelector('#loading').style.display = 'none'
          this.liveStatus = 'err'
          return
        }
        if (!status) {
          document.querySelector('#loading').style.display = 'none'
          if (!room) {
            this.liveStatus = 'err'
            return
          }
          this.liveObj = data
          this.liveStatus = room.status
          // eslint-disable-next-line eqeqeq
          if (this.liveStatus == 3) {
            //  获取购物车配置信息
            this.getShoppingConf()
          }
          this.anchorObj = user
          // 直播间是否有询底价，是否配置车型 (只有经销商直播才有roomDistributor字段)
          if (room.type === '3') {
            const { roomDistributor } = data
            this.roomDistributor = {
              isInquiry: roomDistributor.is_inquiry,
              isHasCar: roomDistributor.switch_car
            }
          }
          this.changeTitle(room.title)
          this.shareObj = {
            title: room.title,
            desc: room.notice,
            imgUrl: data.share_img,
            link: data.share_url
          }
          // app分享
          this.appShareBtn(this.shareObj)
          // 微信分享
          this.wxSharePage(this.shareObj)
          this.$nextTick(() => {
            libFirst = this.libExample(this.liveId)

            // this.wxPullApp(wxPullAppConfigureFirst, libFirst)
          })
          switch (room.status) {
            // 预告中-直播倒计时处理
            case '2':
              this.createWebsocket()
              // 直播预告
              if (room.prepare_mode === '2') {
                this.$nextTick(() => {
                  // eslint-disable-next-line
                  lpn = TCPlayer('live-player-notice', {
                    plugins: {
                      ContinuePlay: { // 开启续播功能
                        auto: true, // [可选] 是否在视频播放后自动续播
                        text: '上次播放至 ', // [可选] 提示文案
                        btnText: '恢复播放' // [可选] 按钮文案
                      }
                    }
                  })
                  lpn.src(room.prepare_video)

                  lpn.on('ended', () => {
                    this.isShowIllustrate = true
                  })
                  lpn.on('play', () => {
                    this.isShowIllustrate = false
                  })
                  lpn.on('pause', () => {
                    this.isShowIllustrate = true
                  })
                })
              }
              this.nowTime = dayjs(room.now_time)
              this.leftShowTime = dayjs(room.start_time).format('MM-DD HH:mm')
              if (this.nowTime.isBefore(dayjs(room.start_time))) {
                this.leftSec = dayjs(room.start_time).diff(dayjs(this.nowTime), 'second')
                this.leftTime = this.checkLeftTime(this.leftSec)
                this.timer = setInterval(() => {
                  if (this.leftSec <= 0) {
                    // 预告结束开始直播，需要重新获取信息
                    this.liveSocket.close()
                    this.socketChange = true
                    clearInterval(this.timer)
                    // 直播预告结束但是还未开始，开始通过websoket开始
                    this.liveStatus = '6'
                  }
                  this.leftSec = this.leftSec - 1
                  this.leftTime = this.checkLeftTime(this.leftSec)
                }, 1000)
              } else {
                this.liveStatus = '6'
              }

              break
            // 直播中
            case '3':
              this.liveStart()
              break
            // 直播结束
            case '4':
              break
            // 生成回放
            case '5':
              this.tabActived = 1
              this.replayId = room.live_round_id
              // 点播相关配置
              if (room.appid && room.file_id) {
                this.$nextTick(() => {
                  // eslint-disable-next-line
                  const player = TCPlayer('live-player-review', {
                    appID: room.appid,
                    fileID: room.file_id,
                    plugins: {
                      ContinuePlay: { // 开启续播功能
                        auto: true, // [可选] 是否在视频播放后自动续播
                        text: '上次播放至 ', // [可选] 提示文案
                        btnText: '恢复播放' // [可选] 按钮文案
                      }
                    }
                  })
                })
              }
              // 获取回放评论列表
              this.getReviewCommentList()
              break
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 直播从预告到开始
    liveStart () {
      this.$nextTick(() => {
        this.livePlayer()
        this.createWebsocket()
      })
    },
    livePlayer () {
      const that = this
      // 直播相关配置
      var options = {
        m3u8: this.liveObj.room.play_url.hls_url,
        flv: this.liveObj.room.play_url.flv_url,
        rtmp: this.liveObj.room.play_url.rtmp_url,
        live: true,
        poster: {
          style: 'stretch',
          src: this.liveObj.room.img
        },
        pausePosterEnabled: false,
        autoplay: false,
        width: '100%',
        height: that.type === 'pc' ? '420' : '210',
        flash: false,
        x5_player: true,
        listener: function (msg) {
          if (msg.type === 'pause' || msg.type === 'play') {
            that.playStatus = msg.type
          }
          if (msg.type === 'pause') {
            that.pauseCounter++
          }
          // 首次播放
          if (msg.type === 'play') {
            that.playCounter++
            if (that.playCounter === 1) {
              let timerNet = null
              timerNet = setTimeout(() => {
                clearInterval(timerNet)
                if (!that.timeupdateCounter && that.playStatus === 'play' && !that.pauseCounter) {
                  that.showErrorInfo('网络不佳，请稍后重试')
                }
              }, 6000)
            }
          }
          if (msg.type === 'error') {
            window.tcplayer.destroy()
            that.liveStatus = '7'
          }
          if (msg.type === 'timeupdate') {
            if (!that.timeupdateCounter) {
              that.timeupdateCounter = true
            }
          }
        }
      }
      let timerError = null
      timerError = setTimeout(() => {
        clearInterval(timerError)
        if (that.liveStatus === '7') {
          that.liveStatus = '3'
          this.$nextTick(() => {
            // eslint-disable-next-line no-undef
            window.tcplayer = new TcPlayer('live-player', options)
          })
        }
      }, 3000)
      // eslint-disable-next-line
      window.tcplayer = new TcPlayer('live-player', options)
    },
    // tab切换
    tabSelect (index) {
      // 评论高度改变做特殊处理
      if (this.tabActived !== index) {
        if (this.tabActived === 0) {
          // 评论变简介存储高度
          const inEnd = this.$refs.commentList.scrollHeight === this.$refs.commentList.scrollTop + this.$refs.commentList.offsetHeight
          this.tabCommentHeight = inEnd ? 'bottom' : this.$refs.commentList.scrollTop
          this.tabActived = index
        } else {
          // 简介变评论重新改变高度
          this.tabActived = index
          this.$nextTick(() => {
            this.$refs.commentList.scrollTop = this.tabCommentHeight === 'bottom' ? this.$refs.commentList.scrollHeight : this.tabCommentHeight
          })
        }
      }
    },
    // 创建socket
    async createWebsocket () {
      const that = this
      const type = this.liveStatus === 3 || this.liveStatus === '3' ? 'live' : 'waitLive'
      // 获取当前时间后再连接socket
      XHR.getNowTime().then(res => {
        const { data, status } = res.data
        if (!status) {
          const nowTime = data.timestamp
          const sign = md5(`${type}${this.liveId}${nowTime}live.360che.com`)
          let socketUrl = `wss://${!(location.host.indexOf('live-h5.360che.com') > -1) ? 'live-test.360che.com' : 'live.360che.com'}/wss?roomId=${this.liveId}&type=${type}&timestamp=${nowTime}&sign=${sign}`
          if (this.myInfo.uid && this.myInfo.uid !== '0') {
            socketUrl = `${socketUrl}&uid=${this.myInfo.uid}`
          }
          this.liveSocket = new WebSocket(socketUrl) // 监听端口
          this.liveSocket.onopen = () => { // 监听是否连接服务器成功触发
            // console.log('log: connect')
            that.socketChange = false
            that.socketLock = false
            that.reconectNum = 0
            // 心跳检测
            that.heartCheck()
          }
          // 接收到服务器数据触发
          this.liveSocket.onmessage = (event) => {
            if (event.data.indexOf('{') < 0) {
              return
            }
            const obj = JSON.parse(event.data)
            // 谁谁进入了直播间
            if (obj.action === 203) {
              if (that.myInfo.fd && obj.info.fd === that.myInfo.fd) {
                return
              }
              if (!that.myInfo.fd) {
                that.myInfo.fd = obj.info.fd
              }
              if (that.$refs.commentList) {
                // 滚动至底部
                const inEnd = that.$refs.commentList.scrollHeight === that.$refs.commentList.scrollTop + that.$refs.commentList.offsetHeight
                that.commentList.push(obj.info)
                that.$nextTick(() => {
                  if (inEnd) {
                    that.$refs.commentList.scrollTop = that.$refs.commentList.scrollHeight
                  }
                })
              } else {
                that.commentList.push(obj.info)
              }
            }
            // 更新直播间在线人数
            if (obj.action === 105) {
              this.onlineNumber = obj.onlineNumber
              // 点赞
            }
            // 获取观看数
            if (obj.action === 106) {
              this.zanNumber = obj.zanNumber
              this.likeLock = false
              this.$refs.rightNav.showLikeAnimation()
            }
            // 评论列表
            if (obj.action === 103) {
              // 若是自己的评论则测试
              if (obj.uid === this.myInfo.uid) {
                this.commentLock = false
                clearTimeout(this.commentTimer)
                try {
                  // eslint-disable-next-line
                  Truckhome_eventFun('ck_zbc', '', this.liveId)
                } catch (e) {
                }
              }
              // 滚动至底部
              if (that.$refs.commentList) {
                const isInEnd = that.$refs.commentList.scrollHeight === that.$refs.commentList.scrollTop + that.$refs.commentList.offsetHeight
                that.commentList.push(obj)
                that.$nextTick(() => {
                  if (isInEnd) {
                    that.$refs.commentList.scrollTop = that.$refs.commentList.scrollHeight
                  }
                })
              } else {
                that.commentList.push(obj)
              }
            }
            // 评论违规
            if (obj.action === 205) {
              // 若是自己的评论则测试
              if (obj.fromUserFd === this.myInfo.fd) {
                this.showErrorInfo('评论失败,包含敏感内容')
                this.commentLock = false
                clearTimeout(this.commentTimer)
              }
            }
            // 直播开始，只有预告阶段才用到
            if (obj.action === 107) {
              // 收到直播通知后延迟5s再切换到直播流状态，因为h5直播存在延迟，直接切换播放器流地址会报错
              setTimeout(() => {
                clearInterval(that.timer)
                if (lpn != null) {
                  lpn.dispose()
                }
                that.liveStatus = '3'
                that.liveStart()
                this.socketChange = true
                that.liveSocket.close()
              }, 5000)
            }
            // 直播结束
            if (obj.action === 108) {
              window.tcplayer.destroy()
              that.liveStatus = '4'
              this.socketChange = true
              that.liveSocket.close()
            }
            // 直播主播id
            if (obj.action === 109) {
              that.anchorObj.uid = obj.info.uid
            }
            // 直播间标题、封面图、公告信息改变
            if (obj.action === 110) {
              const { isChangeTitle, title, isChangeImg, img, isChangeNotice, notice } = obj.data
              // 标题的改变
              if (isChangeTitle && title) {
                this.liveObj.room.title = title
              }
              // 直播图片的改变
              if (isChangeImg && img) {
                this.liveObj.room.img = img
              }
              // 直播公告的改变
              if (isChangeNotice && notice) {
                this.liveObj.room.h5_notice = notice
              }
            }
            // 心跳包收到回复删除服务器检测定时器
            if (obj.action === 206) {
              if (!obj.status) {
                clearTimeout(that.heartTimer)
                clearTimeout(that.serverTimeout)
                that.heartCheck()
              }
            }
            // 更新转盘抽奖设置
            if (obj.action === 111) {
              const { data } = obj
              this.lotterySetting = data
              if (data.left_time > 0 && data.left_time <= 300) {
                this.getCountDown(data.left_time, 'isShowLotteryLeftTime')
              }
            }
            // 留资活动入口信息
            if (obj.action === 112 || obj.action === 113) {
              this.formEntryInfo = { ...this.formEntryInfo, ...obj.data }
            }
            // 主播端推送 推荐大图、讲解商品
            if (obj.action === 114 || obj.action === 115) {
              this.shoppingConf.goods_info = obj.data
            }
            // 购物车开关改变
            if (obj.action === 116) {
              this.shoppingConf.shopping_open = obj.data.shopping_open + ''
              if (!obj.data.shopping_open && this.isShowGoodList) {
                this.toMarket('close', 'isShowGoodList')
              }
            }
          }
          that.liveSocket.onclose = () => { // 与服务器连接断开触发
            // console.log('log: close')
            // 若不是自动关闭时需要重新连接
            clearTimeout(that.heartTimer)
            clearTimeout(that.serverTimeout)
            if (!that.socketChange) {
              that.socketLock = false
              that.reconnect()
            }
          }
          that.liveSocket.onerror = () => { // 与服务器连接出现错误触发
            // console.log('log: error')
            that.socketLock = false
            this.reconnect()
          }
        } else {
          this.socketError = true
        }
      }).catch(() => {
        this.socketError = true
      })
    },
    reconnect () {
      if (this.socketLock) {
        return
      }
      this.socketLock = true
      // 重连3次则异常
      if (this.reconectNum < 4) {
        // console.log('log: reconect')
        this.socketLock = true
        this.reconectNum++
        this.reconectTimer && clearTimeout(this.reconectTimer)
        this.reconectTimer = setTimeout(() => {
          this.myInfo.fd = 0
          this.createWebsocket()
        }, 3000)
      } else {
        this.socketError = true
      }
    },
    // socket心跳检测
    heartCheck () {
      // 发送心跳,每55秒发送一次
      this.heartTimer = setTimeout(() => {
        const sendMsg = JSON.stringify({
          roomId: this.liveId,
          action: 'heartBeat'
        })
        this.liveSocket.send(sendMsg)
        // console.log('log: heart2')
        // 如果超过一定时间还没重置，说明后端主动断开了
        // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
        this.serverTimeout = setTimeout(() => {
          this.liveSocket.close()
        }, 54000)
      }, 55000)
    },
    // 回放页获取评论列表
    getReviewCommentList () {
      XHR.getComment({
        id: this.liveId,
        live_round_id: this.replayId
      }).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.commentList = data
          this.$nextTick(() => {
            this.commentLoad = true
            if (this.commentList.length) {
              this.$refs.commentList.scrollTop = this.$refs.commentList.scrollHeight
            }
          })
        }
      })
    },
    beforeComment () {
      if (!this.myInfo.uid || this.myInfo.uid === '0') {
        this.toLogin()
        // window.truckLogin.toLogin(this.onLoginCallback)
      }
    },
    comment () {
      if (!this.commentVal.trim()) {
        return
      }
      if (this.liveStatus === 3 || this.liveStatus === '3') {
        this.commentZhibo()
      } else {
        // 非app页面回放页进行评论
        this.commentSend(this.commentVal.trim())
      }
    },
    // 直播中评论
    commentZhibo () {
      if (this.commentLock) {
        return
      }
      if (this.socketError) {
        this.showErrorInfo('发布失败,请稍后再试')
        return
      }
      // 发布评论
      const sendMsg = JSON.stringify({
        roomId: this.liveId,
        action: 'sendMessage',
        params: {
          content: this.commentVal.trim(),
          uid: this.myInfo.uid,
          nickname: this.myInfo.nickname
        }
      })
      this.liveSocket.send(sendMsg)
      this.commentVal = ''
      this.commentTimer = setTimeout(() => {
        this.showErrorInfo('发布失败,请稍后再试')
        this.commentLock = false
      }, 3000)
    },
    // 点赞
    toLike () {
      if (this.likeLock) {
        return
      }
      if (this.socketError) {
        this.showErrorInfo('点赞失败,请稍后再试')
        return
      }
      // 发布评论
      const sendMsg = JSON.stringify({
        roomId: this.liveId,
        action: 'zan'
      })
      this.likeLock = true
      this.liveSocket.send(sendMsg)
    },
    // app页面触发评论
    appComment () {
      // 未登录触发登录
      if (!this.myInfo.uid || this.myInfo.uid === '0') {
        // window.truckLogin.toLogin(this.onLoginCallback)
        this.toLogin()
      }
      // 触发评论
      window.acceptWebViewCallback('onCommentCallBack', this.onCommentCallBack)
      window.callNativeMethod('onLiveComment', {})
    },
    // 评论回调方法
    onCommentCallBack (data) {
      if (data) {
        const res = typeof data === 'object' ? data : JSON.parse(data)
        // 评论成功后
        if (res.content) {
          this.commentSend(res.content)
        }
      }
    },
    // 回放页进行评论
    commentSend (val) {
      if (this.commentLock) {
        return
      }
      XHR.comment({
        rid: this.liveId,
        live_round_id: this.replayId,
        uid: this.myInfo.uid,
        content: val
      }).then(res => {
        this.commentLock = false
        const { data, status } = res.data
        data.msg_type = 'text'
        if (!status) {
          const isInEnd = this.$refs.commentList.scrollHeight === this.$refs.commentList.scrollTop + this.$refs.commentList.offsetHeight
          this.commentList.push(data)
          this.$nextTick(() => {
            if (isInEnd) {
              this.$refs.commentList.scrollTop = this.$refs.commentList.scrollHeight
            }
          })
          this.commentVal = ''
          try {
            // eslint-disable-next-line
            Truckhome_eventFun('ck_zbc', '', this.liveId)
          } catch (e) {
          }
        } else if (status === 10021) {
          this.showErrorInfo('评论失败,包含敏感内容')
        } else {
          this.showErrorInfo('发布失败,请稍后再试')
        }
      }).catch(() => {
        this.showErrorInfo('发布失败,请稍后再试')
        this.commentLock = false
      })
    },
    // app登录成功后需要获取关注状态
    getFollowStatus () {
      XHR.getFollowStatus({
        uid: this.myInfo.uid,
        fuid: this.anchorObj.uid
      }).then(res => {
        const { data, status } = res.data
        if (!status) {
          this.$set(this.anchorObj, 'is_follow', data.is_follow)
        }
      })
    },
    // 关注
    followUser () {
      if (this.followLock) {
        return
      }
      if (!this.myInfo.uid || this.myInfo.uid === '0') {
        this.toLogin()
        // window.truckLogin.toLogin(this.onLoginCallback)
        return
      }
      this.followLock = true
      if (this.anchorObj.is_follow) {
        // 取消关注
        XHR.cancelFollowUser({
          fuid: this.anchorObj.uid,
          userId: this.myInfo.uid
        }).then(res => {
          this.followLock = false
          const { status } = res.data
          if (!status) {
            this.showErrorInfo('已取消关注')
            this.$set(this.anchorObj, 'is_follow', 0)
          } else {
            this.showErrorInfo('取消关注失败')
          }
        }).catch(() => {
          this.showErrorInfo('取消关注失败')
          this.followLock = false
        })
      } else {
        // 关注
        XHR.followUser({
          fuid: this.anchorObj.uid,
          userId: this.myInfo.uid
        }).then(res => {
          this.followLock = false
          const { status } = res.data
          if (!status) {
            this.showErrorInfo('关注成功')
            this.$set(this.anchorObj, 'is_follow', 1)
          } else if (status === 10002) {
            // 已经关注
            this.showErrorInfo('关注成功')
            this.$set(this.anchorObj, 'is_follow', 1)
          } else {
            this.showErrorInfo('关注失败')
          }
        }).catch(() => {
          this.followLock = false
          this.showErrorInfo('关注失败')
        })
      }
    },
    // 输入框取得焦点
    inputFocus () {
      this.commentBottom = this.$refs.commentList.scrollHeight === this.$refs.commentList.scrollTop + this.$refs.commentList.offsetHeight
    },
    // iosApp新增样式规则
    addStylesheetRules (rules) {
      var styleEl = document.createElement('style')
      document.head.appendChild(styleEl)
      var styleSheet = styleEl.sheet
      for (var i = 0; i < rules.length; i++) {
        var j = 1
        var rule = rules[i]
        var selector = rule[0]
        var propStr = ''
        if (Array.isArray(rule[1][0])) {
          rule = rule[1]
          j = 0
        }
        for (var pl = rule.length; j < pl; j++) {
          var prop = rule[j]
          propStr += prop[0] + ': ' + prop[1] + (prop[2] ? ' !important' : '') + ';\n'
        }
        styleSheet.insertRule(selector + '{' + propStr + '}', styleSheet.cssRules.length)
      }
    },
    // 获取直播间推广数据
    getPromoteData () {
      XHR.getPromoteData({
        id: this.liveId
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.adData = data
          // 曝光加埋点
          if (data.images.length) {
            data.images.forEach(item => {
              this.sendTruckhomeEvent('v_gg_live', '', item.id)
            })
          }
        }
      }).catch((err) => {
        console.error(err)
      })
    },
    openUrl (url, type = '', id = '') {
      if (type === 'img') {
        this.sendTruckhomeEvent('ck_gg_live', '', id)
      }
      if (url) {
        window.location.href = url
      }
    }
  }
}
</script>
<style lang="less">
/*.vjs-fullscreen-control{*/
/*  display: none!important;*/
/*}*/
.vcp-error-tips {
  display: none !important;
}

.vcp-poster-pic.stretch {
  object-fit: cover !important;
}

.vjs-poster {
  background-size: cover !important;
}
</style>
<style lang="less" scoped>
@import url(../../mixin/public.css);

body {
  overflow-x: hidden;
}

/deep/ .vjs-button-icon {
  width: 48px !important;
  height: 48px !important;
  margin-left: auto;
  margin-right: auto;
  background-image: url("../../assets/play.png");
  background-size: 100% 100%;

  svg {
    display: none;
  }

}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 750px;
  margin: 0 auto;
}

.top-right-nav {
  position: absolute;
  top: 74px;
  left: 50%;
  width: 58px;
  margin-left: 120px;
  z-index: 2;

  ul {
    li {
      position: relative;
      margin-bottom: 6px;

      img {
        display: block;
        width: 58px;
        height: 58px;
        cursor: pointer;
      }

      span {
        position: absolute;
        bottom: 1px;
        left: 50%;
        transform: translateX(-50%) scale(0.5);
        color: #fff;
        text-align: center;
        display: block;
        width: 116px;
        font-size: 18px;
      }
    }

    li:nth-last-of-type(1) {
      margin-bottom: 0;

      span {
        bottom: 2px;
      }
    }

    .lottery {
      span {
        line-height: 26px;
      }
    }

    .form {
      span {
        line-height: 30px;
      }
    }
  }
}

.live-player {
  flex: none;
  height: 210px;
  width: 100%;
}

.openAppBtn {
  position: relative;
  width: 91.5%;
  margin: 10px auto;
  height: 40px;
  background: #2395f1;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
}

.nav {
  padding: 0 16px;
  width: 100%;
  height: 44px;
  background: #fff;
  display: flex;
  box-sizing: border-box;
  box-shadow: 0 1px 0 0 #F5F5F5;

  .nav-item {
    position: relative;
    margin-right: 25px;
    /*width: 65px;*/
    text-align: center;
    height: 44px;
    font-size: 16px;
    color: rgba(3, 16, 42, 0.6);
    cursor: pointer;

    p {
      position: relative;
      height: 32px;
      line-height: 16px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }

    &.on {
      position: relative;
      color: #03102a;
      font-weight: bold;
      font-size: 20px;

      p {
        line-height: 20px;
      }

      &:after {
        content: '';
        width: 12px;
        height: 4px;
        /*border-radius: 4px;*/
        background: #0089FF;
        position: absolute;
        left: calc(50% - 8px);
        top: 36px;
        right: 0;
        /*bottom: 4px;*/
      }
    }
  }
}

.tab-list {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 1px;
}

.comment-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: rgba(245, 245, 245, 1);
}

.comment-list,
.brief {
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.brief {
  background: rgba(255, 255, 255, 1);

  h4 {
    font-size: 18px;
    font-weight: 500;
    color: rgba(3, 16, 42, 1);
    line-height: 26px;
    padding: 8px 16px;
    word-break: break-all;
  }

  .notice {
    padding: 8px 16px;
    font-size: 14px;
    line-height: 22px;
    word-break: break-all;
    font-weight: normal;

    img {
      width: 49px;
      margin-bottom: 6px;
    }

    article {
      color: #4A4A4A;
      font-size: 14px;
    }

    .flow-chart-img {
      margin-top: 12px !important;
    }
  }
}

.flow-chart {
  padding: 16px 16px 8px;
}

.flow-chart-img {
  display: block;
  width: 100% !important;
  margin: 0 auto 8px !important;
}

.empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 180px;
  }

  p {
    font-size: 15px;
    font-weight: 400;
    color: rgba(3, 16, 42, 0.6);
    line-height: 15px;
    padding-top: 16px;
  }
}

.follow-person {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 16px;
  background: rgb(17, 17, 17);

  .head-left {
    position: relative;
    display: flex;
    align-items: center;
    padding: 12px 0;

    .head-icon {
      width: 38px;
      height: 38px;
    }

    .info {
      max-width: 200px;
      margin-left: 6px;

      span {
        display: block;

        &:nth-of-type(1) {
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 16px;
          word-break: break-all;
        }

        &:nth-of-type(2) {
          margin-top: 4px;
          font-size: 10px;
          font-weight: 400;
          color: #C2C3C4;
          line-height: 14px;
        }
      }
    }

  }

  .follow-button {
    width: 40px;
    height: 24px;
    margin-left: 6px;
    background: #FF700E;
    border-radius: 12px;
    line-height: 24px;
    text-align: center;
    color: #FFDAC1;
    font-size: 14px;

    &.followed {
      width: 54px;
      color: #C0C0C1;
      background: #2C2E32;
      /*opacity: 0.12;*/
    }
  }

  .share {
    position: absolute;
    top: 15px;
    right: 10px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}

.comment-list {
  padding: 0 16px;

  .comment-item {
    display: flex;
    padding-bottom: 20px;

    .head-icon {
      width: 42px;
      height: 42px;
      margin-right: 8px;
    }

    .item-info {
      flex: 1;

      .title {
        padding-left: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        position: relative;

        span {
          font-size: 14px;
          color: rgba(3, 16, 42, 0.4);
          line-height: 20px;
          word-break: break-all;
        }

        .tag {
          width: 28px;
          height: 16px;
          background: url("../../assets/anchor-icon.png");
          background-size: cover;
          display: inline-block;
          margin-right: 4px;
          vertical-align: middle;
        }
      }

      .word {
        display: inline-block;
        margin-top: 6px;
        padding: 7px 16px;
        background: #ffffff;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        word-break: break-all;
        border-radius: 14px;
        position: relative;
        margin-left: 8px;
        margin-right: 42px;

        &:before {
          content: '';
          position: absolute;
          left: -8px;
          top: 16px;
          width: 8px;
          height: 6px;
          background-image: url("../../assets/bubble-left.png");
          background-size: cover;
        }
      }

      .link {
        /deep/ a {
          color: #0089FF;
        }
      }
    }
  }

  .comment-item.my {
    .head-icon {
      margin-right: 0px;
      margin-left: 8px;
    }

    .item-info {
      text-align: right;

      .title {
        padding-left: 0;
        padding-right: 4px;
      }
    }

    .word {
      background: #3D91F2;
      color: #ffffff;
      margin-left: 42px;
      margin-right: 8px;

      &:before {
        left: auto;
        right: -8px;
        background-image: url("../../assets/bubble-right.png");
      }
    }
  }

  .enter-live {
    text-align: center;
    padding-bottom: 20px;

    span {
      font-size: 14px;
      color: rgba(229, 98, 21, 1);
      line-height: 20px;

      &:last-child {
        padding-left: 6px;
      }
    }
  }

  &>li:first-of-type {
    padding-top: 20px;
  }
}

.comment-footer {
  background: #ffffff;
  height: 49px;
  width: 100%;
  padding: 7px 16px 8px 16px;
  box-sizing: border-box;
  // background:rgba(3, 16, 42, 0.04);
  color: rgba(3, 16, 42, 0.2);
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.05);
  display: flex;

  .footer-left {
    display: flex;
    justify-content: flex-start;
    color: #03102A;
    flex-shrink: 0;

    .footer-left-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: 2px;
      margin-right: 8px;

      img {
        width: 22px;
      }

      span {
        font-size: 10px;
        margin: 0;
      }

      &:last-child {
        margin-right: 15px;
      }
    }
  }

  .footer-right {
    display: flex;
    flex: 1;
    position: relative;

    button {
      width: 70px;
      height: 34px;
      background: rgba(21, 113, 229, 1);
      border-radius: 6px;
      margin-left: 10px;
      font-size: 16px;
      color: #FFFFFF;

      &.disabled {
        background: rgba(3, 16, 42, 0.04);
        color: rgba(3, 16, 42, 0.2);
      }
    }

    .inputDiv {
      flex: 1;
    }

    .input {
      width: 100%;
      height: 34px;
      display: flex;
      align-items: center;
      background: rgba(3, 16, 42, 0.04);
      border-radius: 6px;
      border: none;
      padding-left: 35px;
      padding-right: 20px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(3, 16, 42, 1);
    }

    input.input {
      -webkit-touch-callout: initial;
      /*系统默认菜单被禁用*/
      -webkit-user-select: initial;
      /*webkit浏览器*/
      -khtml-user-select: initial;
      /*早期浏览器*/
      -moz-user-select: initial;
      /*火狐*/
      -ms-user-select: initial;
      /*IE10*/
      user-select: initial;

      &::-webkit-input-placeholder {
        color: rgba(3, 16, 42, 0.2);
      }

      &:-moz-placeholder {
        color: rgba(3, 16, 42, 0.2);
      }

      &::-moz-placeholder {
        color: rgba(3, 16, 42, 0.2);
      }

      &:-ms-input-placeholder {
        color: rgba(3, 16, 42, 0.2);
      }
    }

    div.input {
      color: rgba(3, 16, 42, 0.2);
    }

    &:before {
      position: absolute;
      left: 12px;
      top: 10px;
      content: '';
      width: 15px;
      height: 15px;
      background-image: url("../../assets/comment-icon.png");
      background-size: cover;
    }
  }
}

/*直播预告、结束*/
.live-trailer,
.live-end {
  width: 100%;
  height: 210px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /*height: auto;*/
    /*max-width: 100%;*/
    /*max-height: 100%;*/
  }

  .trailer-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(3, 16, 42, 0.6);
    /*z-index: 1;*/
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
      text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
      margin-bottom: 10px;
    }

    .label {
      display: flex;

      .left {
        position: relative;
        font-size: 14px;
        color: #ffffff;
        width: 36px;
        height: 24px;
        line-height: 24px;
        background: rgba(209, 68, 86, 0.9);
        border-radius: 4px 0px 0px 4px;
        text-indent: 5px;
        position: relative;

        &:after {
          position: absolute;
          content: '';
          width: 0;
          height: 0;
          right: -8px;
          top: 0;
          border-bottom: 24px solid rgba(209, 68, 86, 0.9);
          border-left: 8px solid transparent;
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }

      .time {
        padding-left: 11px;
        width: 104px;
        height: 24px;
        line-height: 24px;
        background: rgba(86, 86, 86, 0.9);
        border-radius: 0px 4px 4px 0px;
        box-sizing: border-box;
        display: flex;

        em {
          font-size: 14px;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
          line-height: 24px;
        }

        span {
          display: block;
          font-size: 12px;
          transform: scale(0.8);
          font-weight: 400;
          color: rgba(255, 255, 255, 0.7);
          line-height: 24px;
        }
      }
    }

    span {
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 235, 124, 1);
      line-height: 20px;
    }
  }

  .notice-style {
    align-items: flex-start;
    justify-content: flex-start;
    padding-left: 16px;
    padding-top: 14px;
    box-sizing: border-box;

    p {
      margin-bottom: 4px;
    }
  }
}

.live-end .trailer-mask p {
  font-size: 30px;
  text-shadow: none;
}

.head-icon {
  border-radius: 50%;
  position: relative;
  z-index: 0;
  overflow: hidden;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    background: #F9F9F9 url("https://s.kcimg.cn/app/quick/images/default-head.png") no-repeat center center/ 100%;
    text-align: center;
    width: 100%;
    height: 100%;
    line-height: 38px;
    z-index: -1;
    border-radius: 50%;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
}

.my-swiper-wraper {
  position: relative;
  margin: 0 auto;
  z-index: 102;

  .my-swiper {
    width: 91.5%;
    height: 50px;

    figure {
      width: 100%;
      height: 100%;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
      }
    }
  }

  .swiper-pagination {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    --swiper-pagination-color: #0089FF;

    /deep/ .swiper-pagination-bullet {
      margin-right: 4px;
      width: 5px;
      height: 5px;

      &:nth-last-of-type(1) {
        margin-right: 0;
      }
    }

    /deep/ .swiper-pagination-bullet-active {
      width: 11px;
      height: 6px;
      border-radius: 3px;
    }
  }
}

.m-t-12 {
  margin-top: 12px;
}

.m-b-12 {
  margin-bottom: 12px;
}

.m-t-8 {
  margin-top: 6px;
}

.m-b-8 {
  margin-bottom: 6px;
}

@media screen and (min-width: 751px) {
  .top-right-nav {
    margin-left: 300px;
  }

  .live-trailer,
  .live-end {
    width: 100%;
    height: 420px;
    position: relative;
  }

  .live-player {
    height: 420px;
  }

  .my-swiper-wraper {
    width: 100%;

    .my-swiper {
      width: 91.5%;
    }
  }
}
</style>
